__turbopack_context__.v({
  "nav-content-dropdown-link": "JYiTAq_nav-content-dropdown-link",
  "nav-content-menu-arrow-link": "JYiTAq_nav-content-menu-arrow-link",
  "nav-content-menu-link": "JYiTAq_nav-content-menu-link",
});
